import React from "react";
import { Box, TextField, Button, Menu, MenuItem, IconButton, Tooltip, InputAdornment, FormControl, InputLabel, OutlinedInput } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { AccountCircle } from "@mui/icons-material";

const DocsSearch = ({
    searchText,
    setSearchText,
    handleSearch,
    handleMenuClick,
    handleMenuClose,
    anchorEl,
    availableStates,
    selectedAddress,
    setSelectedAddress,
    handleAddressClear,
}) => {
    const handleInputChange = (e) => {
        const newValue = e.target.value;
        setSearchText(newValue);
        handleSearch(newValue); // Trigger search as the user types
    };

    const handleMenuSelect = (address) => {
        setSelectedAddress(address);
        handleMenuClose(address);
    };

    return (
        <div className="tw-flex  tw-gap-2  tw-justify-between tw-p-[5px] max-sm:tw-flex-col max-sm:tw-w-full">
            <FormControl fullWidth>
                <OutlinedInput
                    // id="outlined-adornment-amount"
                    className="tw-w-fit tw-min-w-[300px] max-md:tw-min-w-full max-sm:tw-w-full"
                    placeholder="Search"
                    value={searchText}
                    onChange={handleInputChange}
                    sx={{
                        fontWeight: "400",
                        fontSize: "11px",
                        position: "relative",
                        backgroundColor: "#fff",

                        borderRadius: "6px",
                        height: "41px",
                        "& .MuiOutlinedInput-root": {
                            borderRadius: "6px",
                            height: "41px",
                        },
                    }}
                    size="medium"
                    startAdornment={
                        <InputAdornment position="start">
                            <i className="fi fi-rr-search tw-text-[18px]"></i>
                        </InputAdornment>
                    }
                    // label="Amount"
                />
            </FormControl>

            <Button
                onClick={handleMenuClick}
                sx={{
                    textTransform: "none",
                    fontSize: "14px",
                    fontWeight: "500",
                    fontFamily: "Roboto",
                    border: "0.99px solid #D0D5DD",
                    cursor: "pointer",
                    color: "#344054",
                    height: "41px",
                    borderRadius: "5px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    paddingRight: "8px",
                    backgroundColor: "#fff",
                    lineHeight: "14px",
                    minWidth: "230px",
                    textWrap: "nowrap",
                }}
            >
                <FilterListIcon />
                {selectedAddress ? (
                    <Tooltip title={selectedAddress.label} arrow>
                        <span
                            style={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                maxWidth: "100px",
                                display: "inline-block",
                            }}
                            className="tw-text-nowrap"
                        >
                            {selectedAddress.label}
                        </span>
                    </Tooltip>
                ) : (
                    "Select address"
                )}
                <KeyboardArrowDownIcon />
            </Button>

            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => handleMenuClose(null)}>
                {availableStates.length > 0 ? (
                    availableStates.map((address) => (
                        <MenuItem
                            key={address.value}
                            onClick={() => handleMenuSelect(address)}
                            sx={{
                                backgroundColor: selectedAddress && selectedAddress.value === address.value ? "#D0E8FF" : "transparent",
                            }}
                        >
                            {address.label}
                        </MenuItem>
                    ))
                ) : (
                    <MenuItem disabled>No Addresses Available</MenuItem>
                )}
            </Menu>
        </div>
    );
};

export default DocsSearch;
